// Login-Gate. Wird angezeigt, wenn /api/auth/me 401 liefert.
//
// Bewusst eine eigene Seite (kein Modal), weil's keine andere
// Funktion nebenher gibt — wenn man nicht eingeloggt ist, kann
// man auch nichts anderes tun.

import { useState, type FormEvent } from "react";

import { useLogin } from "@/api/hooks";
import { Button } from "@/components/Button";
import { Logo } from "@/components/Logo";
import { useToast } from "@/components/Toast";

import "./LoginPage.css";

export function LoginPage() {
  const toast = useToast();
  const login = useLogin();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    if (!email.trim() || !password) return;
    login.mutate(
      { email: email.trim(), password },
      {
        onSuccess: (user) => {
          toast.success(`Willkommen, ${user.full_name || user.email}!`);
          // useCurrentUser ist via setQueryData schon aktualisiert;
          // die App rendert ab jetzt das Dashboard.
        },
        onError: (err) => {
          toast.error(
            err.message.includes("401")
              ? "E-Mail oder Passwort falsch."
              : `Anmeldung fehlgeschlagen: ${err.message}`
          );
          setPassword("");
        },
      }
    );
  };

  return (
    <div className="bmd-login-page">
      <main className="bmd-login-card">
        <div className="bmd-login-brand">
          <Logo variant="large" withClaim />
        </div>
        <h1 className="bmd-login-title">Anmelden</h1>
        <p className="bmd-login-sub">Bitte melde dich mit deinen Zugangsdaten an.</p>

        <form onSubmit={handleSubmit} className="bmd-stack-3">
          <div>
            <label className="bmd-label" htmlFor="login-email">
              E-Mail
            </label>
            <input
              id="login-email"
              className="bmd-input"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoFocus
              autoComplete="username"
              required
            />
          </div>
          <div>
            <label className="bmd-label" htmlFor="login-password">
              Passwort
            </label>
            <input
              id="login-password"
              className="bmd-input"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              required
            />
          </div>
          <Button
            variant="primary"
            loading={login.isPending}
            disabled={!email.trim() || !password}
            type="submit"
            style={{ width: "100%", justifyContent: "center" }}
          >
            Anmelden
          </Button>
        </form>
      </main>
      <footer className="bmd-login-footer">
        Fidena · Kanzlei-Automatisierung
      </footer>
    </div>
  );
}
